import { LOCAL_STORAGE_APP_VERSION } from '@/lib/constants/constants.ts'

export function getAppVersion() {
  const localStorageVersion = localStorage.getItem(LOCAL_STORAGE_APP_VERSION)
  return `v${__APP_VERSION__} ${localStorageVersion ? `(${localStorageVersion})` : ''}`
}
